/**
 * Tour steps for the AlternativesDietTable component.
 *
 * @param {Function} t - The i18next translation function from `useTranslation()`.
 * @returns {import('react-joyride').Step[]}
 */
export const getAlternativesDietTableSteps = (t) => [
    {
        target: '[data-tour="adt-info"]',
        title: t('tour.alternativesDietTable.step-info-title'),
        content: t('tour.alternativesDietTable.step-info-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="adt-day-selector"]',
        title: t('tour.alternativesDietTable.step-day-selector-title'),
        content: t('tour.alternativesDietTable.step-day-selector-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="adt-total-row"]',
        title: t('tour.alternativesDietTable.step-totals-title'),
        content: t('tour.alternativesDietTable.step-totals-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="adt-meal-header"]',
        title: t('tour.alternativesDietTable.step-meal-header-title'),
        content: t('tour.alternativesDietTable.step-meal-header-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="adt-expand-btn"]',
        title: t('tour.alternativesDietTable.step-expand-btn-title'),
        content: t('tour.alternativesDietTable.step-expand-btn-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="adt-table-container"]',
        title: t('tour.alternativesDietTable.step-table-title'),
        content: t('tour.alternativesDietTable.step-table-content'),
        disableBeacon: true,
        placement: 'top',
    },
];
